<template>
  <div class="live-video-list">
    <Row>
      <Col :xs="24"
           :sm="20">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入关键词查找..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  filterable
                  placeholder="审核状态...">
            <Option value="0"
                    key="0">未审核</Option>
            <Option value="1"
                    key="1">通过</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.typeid"
                  clearable
                  filterable
                  placeholder="类型...">
            <Option v-for="item in livetypeList"
                    :value="item.id"
                    :key="item.id">{{item.title}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
      <Col :xs="24"
           :sm="2">
      <Button @click="showModel()"
              type="success"
              class="f-l">添加</Button>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer title="添加"
            v-model="showModalStatus"
            width="40"
            scrollable
            :mask-closable="false"
            :loading="loading">
      <Form :model="editInfo"
            ref="editInfoValidate"
            :rules="editInfoValidate"
            action="javascript:void(0)">
        <List>
          <ListItem>
            <FormItem label="标题"
                      prop="title">
              <Input v-model="editInfo.title"
                     placeholder="标题"></Input>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="类型"
                      prop="type_id">
              <Select v-model="editInfo.type_id"
                      clearable
                      filterable
                      placeholder="类型...">
                <Option v-for="item in livetypeList"
                        :value="item.id"
                        :key="item.id">{{item.title}}</Option>
              </Select>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="描述">
              <Input type="textarea"
                     v-model="editInfo.describe_new"
                     placeholder="描述..."></Input>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="内容"
                      prop="describe">
              <UEditor v-model="editor.info"
                       ref="editContent"></UEditor>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="缩略图"
                      prop="thumb">
              <upload-thumb v-model="editInfo.thumb"
                            ref="uploadthumb"
                            :defaultList="thumblist"
                            :autoCropWidth="320"
                            :autoCropHeight="200"
                            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:320*200,大小不超过2M'"></upload-thumb>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="匠人"
                      prop="uuid">
              <Select v-model="editInfo.uuid"
                      clearable
                      filterable
                      placeholder="匠人...">
                <Option v-for="item in tradesmanList"
                        :value="item.uuid"
                        :key="item.uuid">{{item.nickname}}</Option>
              </Select>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="是否收费"
                      prop="is_charge">
              <RadioGroup v-model="editInfo.is_charge">
                <Radio :label="0"
                       border>否</Radio>
                <Radio :label="1"
                       border>是</Radio>
              </RadioGroup>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="收费金额"
                      prop="prices">
              <Input v-model="editInfo.prices"
                     placeholder="收费金额..."></Input>
            </FormItem>
          </ListItem>
          <!-- <ListItem>
            <FormItem label="是否分销"
                      prop="is_fx">
              <RadioGroup v-model="editInfo.is_fx">
                <Radio :label="0"
                       border>否</Radio>
                <Radio :label="1"
                       border>是</Radio>
              </RadioGroup>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="分销比例"
                      prop="fx">
              <Input v-model="editInfo.fx"
                     placeholder="输入分销比例..."></Input>
            </FormItem>
          </ListItem> -->
          <!--<ListItem>-->
          <!--<FormItem label="上传视频" prop="url">-->
          <!--<upload-video v-model="editInfo.url" ref="uploadvideo" :defaultList="videolist"></upload-video>-->
          <!--</FormItem>-->
          <!--</ListItem>-->
          <ListItem>
            <FormItem label="是否推荐"
                      prop="pos_flag">
              <RadioGroup v-model="editInfo.pos_flag">
                <Radio :label="0"
                       border>否</Radio>
                <Radio :label="1"
                       border>是</Radio>
              </RadioGroup>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="是否热门"
                      prop="is_hot">
              <RadioGroup v-model="editInfo.is_hot">
                <Radio :label="0"
                       border>否</Radio>
                <Radio :label="1"
                       border>是</Radio>
              </RadioGroup>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="排序"
                      prop="sort">
              <Input v-model="editInfo.sort"
                     placeholder="排序"></Input>
            </FormItem>
          </ListItem>
          <ListItem>
            <div class="demo-drawer-footer">
              <Button type="primary"
                      @click="editLiveRoom('editInfoValidate')">提交</Button>
            </div>
          </ListItem>
        </List>
      </Form>
    </Drawer>
    <!-- 图片查看 end -->
    <Drawer :title="commentDetail.title"
            :closable="true"
            scrollable
            width="50"
            :mask-closable="false"
            v-model="commentDrawerStatus">
      <Table :columns="commentColumns"
             :data="commentDetail.list"
             no-data-text="没有评论"
             size="small"></Table>
      <!-- <p v-for="(item,key) in commentDetail.list" :key="key">{{ item.content }}{{ item.created_at }}</p> -->
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from "../common/ueditor";
// import Video from '../common/video'
export default {
  name: "live-video-list",
  data () {
    const validateTypeid = (rule, value, callback) => {
      if (this.editInfo.type_id === "" || this.editInfo.type_id == null) {
        callback(new Error("请选择类型"));
      } else {
        callback();
      }
    };
    const validateUuid = (rule, value, callback) => {
      if (this.editInfo.uuid === "" || this.editInfo.uuid == null) {
        callback(new Error("请选择匠人"));
      } else {
        callback();
      }
    };
    const validateThumb = (rule, value, callback) => {
      console.log(this.$refs["uploadthumb"].uploadList);
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        callback();
      } else {
        callback(new Error("请上传封面图"));
      }
    };
    const validateDescribe = (rule, value, callback) => {
      if (this.editor.info != "") {
        callback();
      } else {
        callback(new Error("请输入描述"));
      }
    };
    // const validateVideo = (rule, value, callback) => {
    //     if (this.$refs["uploadvideo"].videoList.length > 0) {
    //         callback(new Error('请上传视频'));
    //     } else {
    //         callback();
    //     }
    // };
    return {
      loading: true,
      dataloading: true,
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      // 编辑器用的
      editor: {
        info: ""
      },
      isClear: false,
      title: "",
      formItem: {
        key: "",
        status: "",
        livestatus: "",
        typeid: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "排序",
          width: 100,
          key: "name",
          render: (h, params) => {
            return h("div", [
              h(
                "Input",
                {
                  props: {
                    value: params.row.sort
                  },
                  on: {
                    "on-enter": value => {
                      this.editSort(params.row.id, value.target.value);
                    }
                  }
                },
                "排序"
              )
            ]);
          }
        },
        {
          title: "标题",
          key: "title",
          minWidth: 150
        },
        {
          title: "商户名称",
          key: "title",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.tradesman != null
                  ? params.row.tradesman.nickname
                  : ""
              )
            ]);
          }
        },
        {
          title: "类型",
          key: "title",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.type != null ? params.row.type.title : ""
              )
            ]);
          }
        },
        {
          title: "封面图",
          key: "headimgurl",
          width: 90,
          render: (h, params) => {
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: this.$publicData.ossUrl + params.row.thumb,
                    shape: "square",
                    size: "large"
                  }
                },
                ""
              )
            ]);
          }
        },
        {
          title: "描述",
          key: "describe_new",
          width: 400,
          tooltip: true
        },
        {
          title: "是否收费",
          width: 90,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.is_charge == 1 ? "是" : "否")
            ]);
          }
        },
        {
          title: "收费金额",
          width: 90,
          key: "prices"
        },
        // {
        //   title: "是否分销",
        //   width: 90,
        //   render: (h, params) => {
        //     return h("div", [
        //       h("span", {}, params.row.is_fx == 1 ? "是" : "否")
        //     ]);
        //   }
        // },
        // {
        //   title: "分销比例",
        //   width: 90,
        //   key: "fx"
        // },
        {
          title: "是否推荐",
          width: 90,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.pos_flag == 1 ? "是" : "否")
            ]);
          }
        },
        {
          title: "是否热门",
          width: 90,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.is_hot == 1 ? "是" : "否")
            ]);
          }
        },
        {
          title: "审核状态",
          width: 90,
          key: "status",
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: params.row.status == 1 ? true : false //控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 350,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.chapter(params.row.id);
                    }
                  }
                },
                "章节"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "success",
                    size: "small",
                    disabled: params.row.comment.length == 0 ? true : false
                  },
                  on: {
                    click: () => {
                      this.showComment(params.row.id);
                    }
                  }
                },
                "查看评论"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index, params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      commentDrawerStatus: false,
      commentBtnLoading: false,
      commentDetail: {
        title: "评论详情",
        list: []
      },
      commentColumns: [
        // 评论详情表格表头
        {
          title: "评论时间",
          key: "created_at",
          width: 170
        },
        {
          title: "内容",
          key: "content",
          minWidth: 300
        },
        {
          title: "评论人",
          key: "xx_staff_name",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.userdata != null ? params.row.userdata.nickname : ""
              )
            ]);
          }
        }
      ],
      showModalStatus: false,
      editInfo: {
        title: "",
        type_id: 0,
        describe: "",
        describe_new: "",
        uuid: "",
        thumb: "",
        is_hot: "",
        pos_flag: 0,
        sort: 0,
        is_charge: 0,
        is_fx: 0,
        fx: 0,
        prices: 0
      },
      editInfoValidate: {
        title: [{ required: true, message: "标题", trigger: "blur" }],
        describe: [
          { required: true, validator: validateDescribe, trigger: "change" }
        ],
        type_id: [
          { required: true, validator: validateTypeid, trigger: "change" }
        ],
        uuid: [{ required: true, validator: validateUuid, trigger: "change" }],
        thumb: [{ required: true, validator: validateThumb, trigger: "change" }]
      },
      thumblist: [],
      videolist: [],
      livetypeList: [],
      isClear: false,
      params: {
        starttime: "",
        endtime: "",
        checkouttime: ""
      },
      tradesmanList: []
    };
  },
  // 组件
  components: {
    UploadThumb,
    UEditor
    // Video
  },
  created: function () {
    this.$api.common.livetype({ size: 9999 }).then(res => {
      if (res.code == 200) {
        this.livetypeList = res.result.list;
      }
    });
    this.$api.tradesman.list({ size: 999999, status: 1 }).then(res => {
      this.tradesmanList = res.result.list;
    });
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.$api.livevideos
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.livevideos.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
    chapter (id) {
      this.$router.push("/liveVideosChapter/list/" + id);
    },
    // 富文本更新时取值
    change (val) {
      this.editor.info = val;
    },
    showModel () {
      this.editInfo = {
        title: "",
        type_id: 0,
        describe: "",
        describe_new: "",
        uuid: "",
        thumb: "",
        is_hot: "",
        pos_flag: 0,
        sort: 0,
        is_charge: 0,
        is_fx: 0,
        fx: 0,
        prices: 0
      };
      this.thumblist = [];
      // this.$refs["editContent"].editor.txt.html("");
      this.$refs["editContent"].message = "";
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail (index, id) {
      this.title = "编辑";
      this.editInfo = {
        title: "",
        type_id: 0,
        describe: "",
        describe_new: "",
        uuid: "",
        thumb: "",
        is_hot: "",
        pos_flag: 0,
        sort: 0,
        is_charge: 0,
        is_fx: 0,
        fx: 0,
        prices: 0
      };
      this.thumblist = [];
      this.$api.livevideos.detail({ id: id }).then(res => {
        this.showModalStatus = !this.showModalStatus;
        this.editInfo = res.result;
        //处理thumb
        if (this.editInfo.thumb != null && this.editInfo.thumb != "") {
          this.thumblist.push({
            name: this.editInfo.thumb,
            url: this.editInfo.thumb,
            status: "finished"
          });
        }
        this.editor.info = this.editInfo.describe;
        // this.$refs["editContent"].editor.txt.html(this.editor.info);
        this.$refs["editContent"].message = this.editor.info;
      });
    },
    // 修改排序
    editSort: function (index, value) {
      this.$api.livevideos.sort({ id: index, sort: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.renderTable(1);
        }
      });
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.livevideos.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.renderTable(1);
            }
          });
        }
      });
    },

    editLiveRoom (name) {
      this.editor.info = this.$refs["editContent"].message;
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.editInfo.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.editInfo.thumb = null;
          }
          this.editInfo.describe = this.editor.info;

          if (this.editInfo.id == null || this.editInfo.id == 0) {
            this.$api.livevideos.create(this.editInfo).then(res => {
              if (res.code == 200) {
                this.renderTable(1);
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.livevideos.edit(this.editInfo).then(res => {
              if (res.code == 200) {
                this.renderTable(1);
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 查看评论
    showComment: function (id) {
      // this.commentBtnLoading = true;
      this.commentDetail.list = [];
      this.$api.liveVideosChapter
        .comment({
          live_videos_id: id,
          size: 9999
        })
        .then(res => {
          console.log(res);
          if (res.code == 200) {
            this.commentDetail.title = "评论";
            if (res.result.list != null) {
              this.commentDetail.list = res.result.list;
            }
            this.commentDrawerStatus = true;
          }
          this.commentBtnLoading = false;
        });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status,
        livestatus: this.formItem.livestatus,
        type_id: this.formItem.typeid
      };
      this.$api.livevideos.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.role_ids = res.result.role_ids;
          this.pages.total = res.result.total;
        }
      });
      return;
    }
  }
};
</script>

<style scoped>
/* /deep/ .ivu-select-dropdown {
  z-index: 10002 !important;
} */
/deep/ .toolbar.w-e-toolbar {
  width: 100%;
}
</style>
